const styles = {
    avatarLogoStyle: {
        backgroundColor: '#FFFFFF',
        backgroundImage: 'url(http://via.placeholder.com/350x150)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderColor: 'white',
        borderRadius: 0 /*dynamically set*/,
        borderStyle: 'solid',
        borderWidth: 0, /* dynamically set*/ 
        height: 0 /*dynamically set*/,
        position: 'relative',
        top: 0 /*dynamically set*/,
        width: 0 /*dynamically set*/,
    }
};

export { styles as logoStyles };


// WEBPACK FOOTER //
// ./src/js/components/Logo/styles.ts